import React from 'react'
import {Box, Skeleton} from "@mui/material";

const AdviceItemPlaceholder = () => {

    return <Box sx={ {border: '1px solid #2632384D', borderRadius: '5px', padding: '24px'} }>
        <Skeleton width={316} height={48}/>
        <Skeleton width={316} height={208}/>
        <Skeleton width={105} height={40}/>
        <Skeleton width={316} height={80}/>
        <Skeleton width={316} height={70}/>
    </Box>
}

export default AdviceItemPlaceholder